import {F} from '../../ladmin/utils'
import {Controller} from '../../object/ParkingLot'
let TIMEOUT = 10000
const state = {
  parkingLotList: [],
  controllerList: [],
  personControllerList: [],
  unDirControllerList:[]
}
const getters = {
  findParkingLot: (state) => (id) => {
    return state.parkingLotList.find(p => p.id === id)
  },
  findController: (state) => (id) => {
    return state.controllerList.find(p => p.id === id)
  },
}

// 转换接口
let controllerTransDict = {
  parklotId: 'parkingLotId'
}

const mutations = {
  setParkingLotList (state, list) {
    if (list instanceof Array) {
      state.parkingLotList = list
    }
  },
  setControllerList (state, list) {
    if (list instanceof Array) {
      state.controllerList = list
    }
  },
  setPersonControllerList (state, list) {
    if (list instanceof Array) {
      state.personControllerList = list
    }
  },
  setUnDirControllerList (state, list) {
    if (list instanceof Array) {
      state.unDirControllerList = list
    }
  }
}

const actions = {
  async getParkingLotList ({dispatch, commit}) {
    let {items, amount} = await dispatch('getDataList', {
      url: '/parkApi/smaco/park/park/list',
      pagination: {page: 1, rowsPerPage: 10000},
    }, {root: true})
    return items
  },
  async getAllControllers ({dispatch, commit, getters, state}) {
    let {items} = await dispatch('getDataList', {
      url: '/parkApi/smaco/park/dirgate/list/beauty',
      pagination: {page: 1, rowsPerPage: 10000},
      search: {key: 'passType', value: '1'}
    }, {root: true})
    return items
  },
  async getAllUnDirControllers ({dispatch, commit, getters, state}) {
    let {items} = await dispatch('getDataList', {
      url: '/parkApi/smaco/park/gate/list',
      pagination: {page: 1, rowsPerPage: 10000},
    }, {root: true})
    return items
  },
  async getAllPersonControllers ({dispatch}) {
    let {items} = await dispatch('getDataList', {
      url: '/parkApi/smaco/park/dirgate/list/beauty',
      pagination: {page: 1, rowsPerPage: 10000},
      search: {key: 'passType', value: '0'}
    }, {root: true})
    return items
  },
  async initControllers ({dispatch, commit}) {
    let [parkingLots, controllers, personControllers,unDirControllers] = await Promise.all([
      dispatch('getParkingLotList'),
      dispatch('getAllControllers'),
      dispatch('getAllPersonControllers'),
      dispatch('getAllUnDirControllers')
    ])
    //console.log('结束卡口查询')00
    let gateList = []
    controllers.forEach((c, i, controllers) => {
      for(let i=0;i<c.gateInfo.park.length;i++){
        let o = Object.create(c)
        o.parkingLot = parkingLots.find(p => p.id === c.gateInfo.park[i].id)
        gateList.push(new Controller(o))
      }
    })
    let personGateList = []
    personControllers.forEach((c, i, personControllers) => {
      for(let i=0;i<c.gateInfo.park.length;i++){
        let o = Object.create(c)
        o.parkingLot = parkingLots.find(p => p.id === c.gateInfo.park[i].id)
        personGateList.push(new Controller(o))
      }
    })

    commit('setParkingLotList', parkingLots)
    commit('setControllerList', gateList)
    commit('setPersonControllerList', personGateList)
    commit('setUnDirControllerList', unDirControllers)
    return controllers
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
